<template>
  <button
    type="button"
    @click="handleClick(item)"
  >
    <vetster-badge
      :label="item.name"
      size="sm"
      color="neutral"
      variant="pill"
      class="cursor-pointer hover:bg-ocean-100 hover:border-ocean-200 data-[active]:hover:bg-ocean-700 data-[active]:bg-ocean-950 data-[active]:text-white"
      :data-active="hasFacet(item)"
    />
  </button>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowRight,
  faCircleNotch,
} from '@fortawesome/pro-light-svg-icons';

import VetsterBadge from '@/components/VetsterBadge';
import InteractsWithGlobalSearch from '@/mixins/InteractsWithGlobalSearch';

library.add({
  faArrowRight,
  faCircleNotch,
});

export default {
  name: 'VetsterGlobalSearchPill',

  components: { VetsterBadge },

  mixins: [InteractsWithGlobalSearch],

  props: {
    index: {
      type: Number,
      default: 0,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    async handleClick(item) {
      await this.toggleFacet(item.value, !!this.multiple);

      return this.$bus.$emit('global-search:facet-selected', item.value);
    },
    hasFacet(item) {
      return Object.prototype.hasOwnProperty.call(this.getFacets, item.value);
    },
  },
};
</script>
